import { g as f } from "./_commonjsHelpers-qHz6-ygi.js";
var E = function(r) {
  return h(r) && !b(r);
};
function h(e) {
  return !!e && typeof e == "object";
}
function b(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || p(e);
}
var C = typeof Symbol == "function" && Symbol.for, A = C ? Symbol.for("react.element") : 60103;
function p(e) {
  return e.$$typeof === A;
}
function D(e) {
  return Array.isArray(e) ? [] : {};
}
function t(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? l(D(e), e, r) : e;
}
function O(e, r, a) {
  return e.concat(r).map(function(s) {
    return t(s, a);
  });
}
function y(e, r) {
  if (!r.customMerge)
    return l;
  var a = r.customMerge(e);
  return typeof a == "function" ? a : l;
}
function B(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function g(e) {
  return Object.keys(e).concat(B(e));
}
function d(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function k(e, r) {
  return d(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function v(e, r, a) {
  var s = {};
  return a.isMergeableObject(e) && g(e).forEach(function(F) {
    s[F] = t(e[F], a);
  }), g(r).forEach(function(F) {
    k(e, F) || (d(e, F) && a.isMergeableObject(r[F]) ? s[F] = y(F, a)(e[F], r[F], a) : s[F] = t(r[F], a));
  }), s;
}
function l(e, r, a) {
  a = a || {}, a.arrayMerge = a.arrayMerge || O, a.isMergeableObject = a.isMergeableObject || E, a.cloneUnlessOtherwiseSpecified = t;
  var s = Array.isArray(r), F = Array.isArray(e), i = s === F;
  return i ? s ? a.arrayMerge(e, r, a) : v(e, r, a) : t(r, a);
}
l.all = function(r, a) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(s, F) {
    return l(s, F, a);
  }, {});
};
var T = l, x = T;
const u = /* @__PURE__ */ f(x);
var o = {
  core: {
    color: {
      brand: {
        midnight: "#00261C",
        midnightTint: "#808D87",
        forest: "#044D29",
        forestTint: "#86A08F",
        ovo: "#0A9828",
        ovoTint: "#95C59A",
        leaf: "#16B639",
        leafTint: "#A2D99C",
        energised: "#38E44C",
        energisedTint: "#ADEAA6",
        offwhite: "#F9F6F3",
        white: "#FFFFFF",
        black: "#000000"
      },
      neutral: {
        darkest: "#292929",
        darker: "#3F3B36",
        dark: "#635E58",
        base: "#8F8982",
        light: "#D4CFCB",
        lighter: "#EBE7E3",
        lightest: "#F9F6F3"
      },
      red: {
        darkest: "#730019",
        darker: "#AE072C",
        dark: "#D62349",
        base: "#E04A6A",
        light: "#EB748E",
        lighter: "#F5B2C1",
        lightest: "#FFEDF1"
      },
      orange: {
        darkest: "#802600",
        darker: "#C13E06",
        dark: "#E95D21",
        base: "#F17B49",
        light: "#F89B73",
        lighter: "#FFC6AD",
        lightest: "#FFEDE5"
      },
      yellow: {
        darkest: "#8F5600",
        darker: "#CB7D07",
        dark: "#E99921",
        base: "#F2AE48",
        light: "#F9C372",
        lighter: "#FFD494",
        lightest: "#FFF3E0"
      },
      green: {
        darkest: "#00261C",
        darker: "#044D29",
        dark: "#007226",
        base: "#0A9828",
        light: "#16B639",
        lighter: "#3BE44C",
        lightest: "#ADEAA6"
      },
      blue: {
        darkest: "#001166",
        darker: "#001EB2",
        dark: "#1F3BCD",
        base: "#4F66DE",
        light: "#788AE9",
        lighter: "#AEBAFB",
        lightest: "#EBEFFF"
      }
    },
    fontFamily: {
      mono: {
        native: "Courier New",
        web: "'IBM Plex Mono', 'Menlo', Courier, monospace"
      },
      heading: {
        native: "OVOCircularTT-Black",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      },
      body: {
        native: "OVOCircularTT-Book",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      },
      bodyBold: {
        native: "OVOCircularTT-Bold",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      }
    },
    fontWeight: {
      book: 450,
      bold: 700,
      black: 900
    },
    fontSize: {
      heading1: {
        small: 32,
        large: 48
      },
      heading2: {
        small: 28,
        large: 36
      },
      heading3: {
        small: 24,
        large: 28
      },
      heading4: {
        small: 20,
        large: 24
      },
      lead: {
        small: 20,
        large: 24
      },
      body: {
        small: 16,
        large: 16
      },
      small: {
        small: 14,
        large: 14
      },
      label: {
        small: 11,
        large: 14
      }
    },
    letterSpacing: {
      base: 0,
      compressed: -0.02,
      extraCompressed: -0.04
    },
    lineHeight: {
      heading1: {
        small: 32,
        large: 48
      },
      heading2: {
        small: 28,
        large: 36
      },
      heading3: {
        small: 28,
        large: 32
      },
      heading4: {
        small: 24,
        large: 28
      },
      lead: {
        small: 24,
        large: 28
      },
      body: {
        small: 24,
        large: 24
      },
      small: {
        small: 20,
        large: 20
      },
      label: {
        small: 20,
        large: 20
      }
    },
    borderWidth: {
      small: 1,
      medium: 2,
      large: 4
    },
    breakpoint: {
      small: 576,
      medium: 768,
      large: 1200
    },
    mediaQuery: {
      small: 576,
      medium: 768,
      large: 1200
    },
    customMediaQuery: {
      "small-and-up": 576,
      "medium-and-up": 768,
      "large-and-up": 1200
    },
    opacity: {
      solid: 1,
      translucent: 0.75,
      transparent: 0.25
    },
    radius: {
      small: 4,
      medium: 8,
      large: 12,
      max: 22
    },
    space: {
      0: 0,
      1: 4,
      2: 8,
      3: 12,
      4: 16,
      5: 20,
      6: 24,
      7: 28,
      8: 32,
      9: 36,
      10: 40,
      11: 44,
      12: 48,
      13: 52,
      14: 56,
      15: 60
    },
    transition: {
      slow: 500,
      medium: 300,
      fast: 200
    }
  },
  semantic: {
    border: {
      graphic: "#FFFFFF",
      differentiated: "#EBE7E3",
      functional: "#635E58"
    },
    branded: {
      surface: "#0A9828",
      message: "#FFFFFF",
      heading: "#FFFFFF"
    },
    neutral: {
      surface: "#EBE7E3",
      message: "#3F3B36",
      surfaceEmphasis: "#3F3B36",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    success: {
      surface: "#ADEAA6",
      message: "#044D29",
      surfaceEmphasis: "#007226",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    warning: {
      surface: "#FFEDE5",
      message: "#C13E06",
      surfaceEmphasis: "#C13E06",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    error: {
      surface: "#FFEDF1",
      message: "#AE072C",
      surfaceEmphasis: "#D62349",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    info: {
      surface: "#EBEFFF",
      message: "#1F3BCD",
      surfaceEmphasis: "#4F66DE",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    data: {
      branded: {
        1: "#0A9828",
        2: "#00261C",
        3: "#007226",
        4: "#ADEAA6"
      },
      electric: {
        1: "#CB7D07",
        2: "#00261C",
        3: "#8F5600",
        4: "#FFD494"
      },
      gas: {
        1: "#4F66DE",
        2: "#00261C",
        3: "#001EB2",
        4: "#AEBAFB"
      }
    },
    focus: {
      outline: "#4F66DE",
      hover: "#AEBAFB",
      surface: "#EBEFFF"
    },
    inverted: {
      surface: "#00261C",
      surfaceAlt: "#044D29",
      border: "#044D29",
      borderAlt: "#0A9828",
      message: {
        branded: "#FFFFFF",
        base: "#FFFFFF",
        secondary: "#D4CFCB",
        link: "#38E44C"
      }
    },
    message: {
      base: "#00261C",
      secondary: "#635E58",
      link: "#044D29",
      error: "#AE072C",
      branded: "#0A9828"
    },
    surface: {
      base: "#F9F6F3",
      cutout: "#EBE7E3",
      elevated: "#FFFFFF"
    }
  },
  component: {
    badge: {
      variants: {
        neutral: {
          background: "#EBE7E3",
          foreground: "#635E58"
        },
        red: {
          background: "#FFEDF1",
          foreground: "#AE072C"
        },
        orange: {
          background: "#FFEDE5",
          foreground: "#C13E06"
        },
        yellow: {
          background: "#FFF3E0",
          foreground: "#8F5600"
        },
        green: {
          background: "#ADEAA6",
          foreground: "#044D29"
        },
        blue: {
          background: "#EBEFFF",
          foreground: "#1F3BCD"
        }
      }
    },
    cta: {
      primary: {
        message: "#FFFFFF",
        surface: "#00261C",
        messageHover: "#FFFFFF",
        surfaceHover: "#044D29",
        messageFocused: "#00261C",
        surfaceFocused: "#00261C",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#00261C",
        surfaceInverted: "#FFFFFF"
      },
      secondary: {
        message: "#00261C",
        surface: "#00261C",
        messageHover: "#044D29",
        surfaceHover: "#000000",
        messageFocused: "#00261C",
        surfaceFocused: "#00261C",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#FFFFFF",
        surfaceInverted: "#FFFFFF"
      },
      destructive: {
        message: "#FFFFFF",
        surface: "#D62349",
        messageHover: "#FFFFFF",
        surfaceHover: "#AE072C",
        messageFocused: "#FFFFFF",
        surfaceFocused: "#D62349",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#FFFFFF",
        surfaceInverted: "#D62349"
      }
    },
    heading1: {
      fontFamily: "OVOCircularTT-Black",
      fontWeight: 900,
      lineHeight: {
        small: 32,
        large: 48
      },
      fontSize: {
        small: 32,
        large: 48
      }
    },
    heading2: {
      fontFamily: "OVOCircularTT-Black",
      fontWeight: 900,
      lineHeight: {
        small: 28,
        large: 36
      },
      fontSize: {
        small: 28,
        large: 36
      }
    },
    heading3: {
      fontFamily: "OVOCircularTT-Bold",
      fontWeight: 700,
      lineHeight: {
        small: 28,
        large: 32
      },
      fontSize: {
        small: 24,
        large: 28
      }
    },
    heading4: {
      fontFamily: "OVOCircularTT-Bold",
      fontWeight: 700,
      lineHeight: {
        small: 24,
        large: 28
      },
      fontSize: {
        small: 20,
        large: 24
      }
    },
    lead: {
      fontFamily: "OVOCircularTT-Book",
      fontWeight: 450,
      lineHeight: {
        small: 24,
        large: 28
      },
      fontSize: {
        small: 20,
        large: 24
      }
    },
    body: {
      fontFamily: "OVOCircularTT-Book",
      fontWeight: 450,
      lineHeight: {
        small: 24,
        large: 24
      },
      fontSize: {
        small: 16,
        large: 16
      }
    },
    small: {
      fontFamily: "OVOCircularTT-Book",
      fontWeight: 450,
      lineHeight: {
        small: 20,
        large: 20
      },
      fontSize: {
        small: 14,
        large: 14
      }
    },
    label: {
      fontFamily: "OVOCircularTT-Book",
      fontWeight: 450,
      lineHeight: {
        small: 20,
        large: 20
      },
      fontSize: {
        small: 11,
        large: 14
      }
    }
  }
}, m = {
  core: {
    color: {
      brand: {
        midnight: "#00261C",
        midnightTint: "#808D87",
        forest: "#044D29",
        forestTint: "#86A08F",
        ovo: "#0A9828",
        ovoTint: "#95C59A",
        leaf: "#16B639",
        leafTint: "#A2D99C",
        energised: "#38E44C",
        energisedTint: "#ADEAA6",
        offwhite: "#F9F6F3",
        white: "#FFFFFF",
        black: "#000000"
      },
      neutral: {
        darkest: "#292929",
        darker: "#3F3B36",
        dark: "#635E58",
        base: "#8F8982",
        light: "#D4CFCB",
        lighter: "#EBE7E3",
        lightest: "#F9F6F3"
      },
      red: {
        darkest: "#730019",
        darker: "#AE072C",
        dark: "#D62349",
        base: "#E04A6A",
        light: "#EB748E",
        lighter: "#F5B2C1",
        lightest: "#FFEDF1"
      },
      orange: {
        darkest: "#802600",
        darker: "#C13E06",
        dark: "#E95D21",
        base: "#F17B49",
        light: "#F89B73",
        lighter: "#FFC6AD",
        lightest: "#FFEDE5"
      },
      yellow: {
        darkest: "#8F5600",
        darker: "#CB7D07",
        dark: "#E99921",
        base: "#F2AE48",
        light: "#F9C372",
        lighter: "#FFD494",
        lightest: "#FFF3E0"
      },
      green: {
        darkest: "#00261C",
        darker: "#044D29",
        dark: "#007226",
        base: "#0A9828",
        light: "#16B639",
        lighter: "#3BE44C",
        lightest: "#ADEAA6"
      },
      blue: {
        darkest: "#001166",
        darker: "#001EB2",
        dark: "#1F3BCD",
        base: "#4F66DE",
        light: "#788AE9",
        lighter: "#AEBAFB",
        lightest: "#EBEFFF"
      }
    },
    fontFamily: {
      mono: {
        native: "Courier New",
        web: "'IBM Plex Mono', 'Menlo', Courier, monospace"
      },
      heading: {
        native: "OVOCircularTT-Black",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      },
      body: {
        native: "OVOCircularTT-Book",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      },
      bodyBold: {
        native: "OVOCircularTT-Bold",
        web: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
      }
    },
    fontWeight: {
      book: 450,
      bold: 700,
      black: 900
    },
    fontSize: {
      heading1: {
        small: "3.2rem",
        large: "4.8rem"
      },
      heading2: {
        small: "2.8rem",
        large: "3.6rem"
      },
      heading3: {
        small: "2.4rem",
        large: "2.8rem"
      },
      heading4: {
        small: "2rem",
        large: "2.4rem"
      },
      lead: {
        small: "2rem",
        large: "2.4rem"
      },
      body: {
        small: "1.6rem",
        large: "1.6rem"
      },
      small: {
        small: "1.4rem",
        large: "1.4rem"
      },
      label: {
        small: "1.1rem",
        large: "1.4rem"
      }
    },
    letterSpacing: {
      base: 0,
      compressed: -0.02,
      extraCompressed: -0.04
    },
    lineHeight: {
      heading1: {
        small: "3.2rem",
        large: "4.8rem"
      },
      heading2: {
        small: "2.8rem",
        large: "3.6rem"
      },
      heading3: {
        small: "2.8rem",
        large: "3.2rem"
      },
      heading4: {
        small: "2.4rem",
        large: "2.8rem"
      },
      lead: {
        small: "2.4rem",
        large: "2.8rem"
      },
      body: {
        small: "2.4rem",
        large: "2.4rem"
      },
      small: {
        small: "2rem",
        large: "2rem"
      },
      label: {
        small: "2rem",
        large: "2rem"
      }
    },
    borderWidth: {
      small: "1px",
      medium: "2px",
      large: "4px"
    },
    breakpoint: {
      small: "576px",
      medium: "768px",
      large: "1200px"
    },
    mediaQuery: {
      small: "@media screen and (min-width: 577px)",
      medium: "@media screen and (min-width: 769px)",
      large: "@media screen and (min-width: 1201px)"
    },
    customMediaQuery: {
      "small-and-up": "(min-width: 577px)",
      "medium-and-up": "(min-width: 769px)",
      "large-and-up": "(min-width: 1201px)"
    },
    opacity: {
      solid: 1,
      translucent: 0.75,
      transparent: 0.25
    },
    radius: {
      small: "4px",
      medium: "8px",
      large: "12px",
      max: "22px"
    },
    space: {
      0: "0",
      1: "4px",
      2: "8px",
      3: "12px",
      4: "16px",
      5: "20px",
      6: "24px",
      7: "28px",
      8: "32px",
      9: "36px",
      10: "40px",
      11: "44px",
      12: "48px",
      13: "52px",
      14: "56px",
      15: "60px"
    },
    transition: {
      slow: "0.5s ease",
      medium: "0.3s ease",
      fast: "0.2s ease"
    }
  },
  semantic: {
    border: {
      graphic: "#FFFFFF",
      differentiated: "#EBE7E3",
      functional: "#635E58"
    },
    branded: {
      surface: "#0A9828",
      message: "#FFFFFF",
      heading: "#FFFFFF"
    },
    neutral: {
      surface: "#EBE7E3",
      message: "#3F3B36",
      surfaceEmphasis: "#3F3B36",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    success: {
      surface: "#ADEAA6",
      message: "#044D29",
      surfaceEmphasis: "#007226",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    warning: {
      surface: "#FFEDE5",
      message: "#C13E06",
      surfaceEmphasis: "#C13E06",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    error: {
      surface: "#FFEDF1",
      message: "#AE072C",
      surfaceEmphasis: "#D62349",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    info: {
      surface: "#EBEFFF",
      message: "#1F3BCD",
      surfaceEmphasis: "#4F66DE",
      messageOnEmphasis: "#FFFFFF",
      border: "#FFFFFF"
    },
    data: {
      branded: {
        1: "#0A9828",
        2: "#00261C",
        3: "#007226",
        4: "#ADEAA6"
      },
      electric: {
        1: "#CB7D07",
        2: "#00261C",
        3: "#8F5600",
        4: "#FFD494"
      },
      gas: {
        1: "#4F66DE",
        2: "#00261C",
        3: "#001EB2",
        4: "#AEBAFB"
      }
    },
    focus: {
      outline: "#4F66DE",
      hover: "#AEBAFB",
      surface: "#EBEFFF"
    },
    inverted: {
      surface: "#00261C",
      surfaceAlt: "#044D29",
      border: "#044D29",
      borderAlt: "#0A9828",
      message: {
        branded: "#FFFFFF",
        base: "#FFFFFF",
        secondary: "#D4CFCB",
        link: "#38E44C"
      }
    },
    message: {
      base: "#00261C",
      secondary: "#635E58",
      link: "#044D29",
      error: "#AE072C",
      branded: "#0A9828"
    },
    surface: {
      base: "#F9F6F3",
      cutout: "#EBE7E3",
      elevated: "#FFFFFF"
    }
  },
  component: {
    badge: {
      variants: {
        neutral: {
          background: "#EBE7E3",
          foreground: "#635E58"
        },
        red: {
          background: "#FFEDF1",
          foreground: "#AE072C"
        },
        orange: {
          background: "#FFEDE5",
          foreground: "#C13E06"
        },
        yellow: {
          background: "#FFF3E0",
          foreground: "#8F5600"
        },
        green: {
          background: "#ADEAA6",
          foreground: "#044D29"
        },
        blue: {
          background: "#EBEFFF",
          foreground: "#1F3BCD"
        }
      }
    },
    cta: {
      primary: {
        message: "#FFFFFF",
        surface: "#00261C",
        messageHover: "#FFFFFF",
        surfaceHover: "#044D29",
        messageFocused: "#00261C",
        surfaceFocused: "#00261C",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#00261C",
        surfaceInverted: "#FFFFFF"
      },
      secondary: {
        message: "#00261C",
        surface: "#00261C",
        messageHover: "#044D29",
        surfaceHover: "#000000",
        messageFocused: "#00261C",
        surfaceFocused: "#00261C",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#FFFFFF",
        surfaceInverted: "#FFFFFF"
      },
      destructive: {
        message: "#FFFFFF",
        surface: "#D62349",
        messageHover: "#FFFFFF",
        surfaceHover: "#AE072C",
        messageFocused: "#FFFFFF",
        surfaceFocused: "#D62349",
        outlineFocused: "#4F66DE",
        backgroundFocused: "#FFFFFF",
        messageInverted: "#FFFFFF",
        surfaceInverted: "#D62349"
      }
    },
    heading1: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 900,
      lineHeight: {
        small: "3.2rem",
        large: "4.8rem"
      },
      fontSize: {
        small: "3.2rem",
        large: "4.8rem"
      }
    },
    heading2: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 900,
      lineHeight: {
        small: "2.8rem",
        large: "3.6rem"
      },
      fontSize: {
        small: "2.8rem",
        large: "3.6rem"
      }
    },
    heading3: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 700,
      lineHeight: {
        small: "2.8rem",
        large: "3.2rem"
      },
      fontSize: {
        small: "2.4rem",
        large: "2.8rem"
      }
    },
    heading4: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 700,
      lineHeight: {
        small: "2.4rem",
        large: "2.8rem"
      },
      fontSize: {
        small: "2rem",
        large: "2.4rem"
      }
    },
    lead: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 450,
      lineHeight: {
        small: "2.4rem",
        large: "2.8rem"
      },
      fontSize: {
        small: "2rem",
        large: "2.4rem"
      }
    },
    body: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 450,
      lineHeight: {
        small: "2.4rem",
        large: "2.4rem"
      },
      fontSize: {
        small: "1.6rem",
        large: "1.6rem"
      }
    },
    small: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 450,
      lineHeight: {
        small: "2rem",
        large: "2rem"
      },
      fontSize: {
        small: "1.4rem",
        large: "1.4rem"
      }
    },
    label: {
      fontFamily: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
      fontWeight: 450,
      lineHeight: {
        small: "2rem",
        large: "2rem"
      },
      fontSize: {
        small: "1.1rem",
        large: "1.4rem"
      }
    }
  }
}, n;
(function(e) {
  e.WEB = "web", e.NATIVE = "native";
})(n || (n = {}));
var w = {
  core: m.core,
  semantic: m.semantic,
  component: m.component
}, S = {
  core: o.core,
  semantic: o.semantic,
  component: o.component
};
function M(e, r, a) {
  a === void 0 && (a = n.WEB);
  var s = { arrayMerge: function(H, c) {
    return c;
  } }, F = a === n.WEB ? w : S, i = u(e, r || {}, s);
  return u(F, i, s);
}
export {
  n as P,
  S as a,
  m as b,
  M as c,
  w as d,
  o as t
};
